import React from 'react';

const Icon = ({
  name,
  size = 20,
  className,
  iconsMap,
  decorative = true,
  title,
}) => {
  if (!name || !iconsMap) return null;

  const iconKey = typeof name === 'string' ? name.toLowerCase() : name;
  const IconComponent = iconsMap[iconKey];

  if (!IconComponent) return null;

  // Cas icône décorative (90% des cas chez toi)
  if (decorative) {
    return (
      <IconComponent
        size={size}
        className={className}
        aria-hidden="true"
        focusable="false"
      />
    );
  }

  // Cas icône porteuse de sens (rare, mais utile ailleurs)
  return (
    <IconComponent
      size={size}
      className={className}
      role="img"
      aria-label={title}
      focusable="false"
    />
  );
};

export default Icon;
